import styled from "styled-components";

export const CellContainerStyled = styled.div`
  display: flex;
  padding: 14px 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  color: #1b1b1b;
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  line-height: 140%;
`;

export const CellButtonStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #3f7f7d;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
  width: max-content;

  &:hover {
    text-decoration: underline;
  }
`;

export const TableOptionsContainerStyled = styled.div`
  height: 100%;
  width: 14px;
`;
